/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutLoginRegionController', ['$scope', function ($scope) {
           
            $scope.Step = 'Login';
            $scope.Config = {};
            $scope.ForgotPasswordVisible = false;

            var controls = [];
            $scope.registerControl = function (name, control) {
                if ($scope[name] === undefined) {
                    $scope[name] = {
                        Wrapper: control,
                        Current: undefined
                    };
                    controls.push(control);
                }
            };
            $scope.setControlValue = function (name, value) {
                if ($scope[name] === undefined)
                    throw new Error(name + ' is not registered as a control on the shared $scope');

                $scope[name].Current = value;
            };

            angular.element(".checkout-login-page").ready(function () {
                if ($(".checkout-loading").length > 0) {
                    $(".checkout-loading").hide();
                }
            });  

        }]);
})();